export const GO_TO_ACTION_FLOW_VIEW = 'go-to-action';
export const TEST_FLOW_VIEW = 'test-flow';
export const COLLAB_GEN_ACTIONS_FLOW_VIEW = 'collab-gen-actions-flow';